export default __webpack_public_path__ + "static/Invictus-fcf18e3110b5fa76f40ec7e778db3f2a.png";